import React, { useEffect, useState } from "react";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import SkyBlueBox from "../component/SkyBlueBox";
import axios from "axios";
import "../component/css/ServiceNotesStatus.css";
import editIcon from "../Image/Pencil.png";
import updateIcon from "../Image/refresh.png";
import cancelIcon from "../Image/close.png";
import calendaricon from "../Image/schedule.png";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FaCheck, FaTimes } from "react-icons/fa";
import MenImg from "../Image/Men.png";

const ServiceNotesStatus = ({ request }) => {
  const [serviceDetailsData, setServiceDetailsData] = useState(null);
  const [note, setNote] = useState("");
  const [activeButton, setActiveButton] = useState("Service-Notes-Status");
  const [arrayNotes, setArrayNotes] = useState([]);
  const [editNoteIndex, setEditNoteIndex] = useState(null);
  const [editNoteContent, setEditNoteContent] = useState("");
  const [editedNoteId, setEditedNoteId] = useState(null);
  const [ImgUrls, setImageUrls] = useState([]);
  const [Loading, setLoading] = useState([]);
  const [partsRequested, setPartsRequested] = useState([]);
  const [isTableVisible, setTableVisible] = useState(true);
  const [areAdditionalColumnsVisible, setAreAdditionalColumnsVisible] =
    useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [diagnosticFiles, setDiagnosticFiles] = useState([]);
  const [fieldServiceReports, setFieldServiceReports] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [newPart, setNewPart] = useState({
    PartNo: "",
    Description: "",
    Quantity: "",
  });

  const toggleTableVisibility = () => {
    setAreAdditionalColumnsVisible(!areAdditionalColumnsVisible);
  };
  const paramsFromUrl = useParams();


  const fetchParts = async () => {
    try {
      const response = await axios.get(
        "/server/service_notes_function/get-parts",
        {
          params: { Record_Id: paramsFromUrl.id },
        }
      );

      if (response.data && response.data["Parts Requested"]) {
        setPartsRequested(response.data["Parts Requested"]);
      }
    } catch (error) {
      console.error("Error fetching parts:", error);
    }
  };

  useEffect(() => {
    if (paramsFromUrl.id) {
      fetchParts();
    }
  }, [paramsFromUrl.id]);

  // useEffect(() => {
  //   if (serviceDetailsData && serviceDetailsData["Parts Requested"]) {
  //     setPartsRequested(serviceDetailsData["Parts Requested"]);
  //   }
  // }, [serviceDetailsData]);

  // useEffect(() => {
  //   if (serviceDetailsData) {
  //     setPartsRequested(
  //       serviceDetailsData["Parts Requested"] ||
  //       serviceDetailsData.parts_requested ||
  //       serviceDetailsData.service_ticket_parts ||
  //       []
  //     );
  //   }
  // }, [serviceDetailsData]);

  const handleAddPartClick = () => {
    setShowForm(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPart((prevPart) => ({
      ...prevPart,
      [name]: value,
    }));
  };

  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const authType = "apikey";
  //     const zapikey =
  //       "1003.fb65bfc9cc4c39e7aa3d85453189fa2a.74bcd11e646cc08d3a2e5fc727ecbd2a";

  //     const apiUrl = `/server/service_notes_function/create-service-ticket-part?auth_type=${encodeURIComponent(
  //       authType
  //     )}&zapikey=${encodeURIComponent(zapikey)}`;

  //     const params = {
  //       id: paramsFromUrl.id,
  //       ...newPart,
  //     };

  //     await axios.post(apiUrl, params);

  //     setPartsRequested((prevParts) => [...prevParts, newPart]);
  //     setNewPart({
  //       PartNo: "",
  //       Description: "",
  //       Quantity: "",
  //     });
  //   } catch (error) {
  //     console.error("Error submitting new part:", error);
  //   }
  // };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const authType = "apikey";
      const zapikey =
        "1003.7cb6dc1e2d0999dc485ec93096d1b2d3.b4c98604c466c0b840f367f2223fd5e6";

      const apiUrl = `/server/service_notes_function/create-service-ticket-part?auth_type=${encodeURIComponent(
        authType
      )}&zapikey=${encodeURIComponent(zapikey)}`;

      const params = {
        id: paramsFromUrl.id,
        ...newPart,
      };

      await axios.post(apiUrl, params);

      // refresh parts from database
      await fetchParts();

      setShowForm(false);

      setNewPart({
        PartNo: "",
        Description: "",
        Quantity: "",
      });

    } catch (error) {
      console.error("Error submitting new part:", error);
    }
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setNewPart({ PartNo: "", Description: "", Qty: "" });
  };

  // const paramsFromUrl = useParams();
  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "/server/service_notes_function/sr1-request-details";
      const params = {
        Record_Id: paramsFromUrl.id,
      };

      try {
        const response = await axios.get(apiUrl, { params });
        setServiceDetailsData(response.data.data);
        fetchNotesData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [paramsFromUrl.id]);

  useEffect(() => {
    fetchNotesData();
  }, []);

  const fetchNotesData = async () => {
    const apiUrl = "/server/service_notes_function/get-notes";
    const params = {
      Record_Id: paramsFromUrl.id,
    };

    try {
      const response = await axios.get(apiUrl, { params });
      const notesWithIds = response.data.Notes.map((note, index) => ({
        ...note,
        Note_Id: note.id,
      }));
      setArrayNotes(notesWithIds);
    } catch (error) {
      console.error("Error fetching notes data:", error);
    }
  };

  const [addingNote, setAddingNote] = useState(false);

  const handleAddClick = async () => {
    if (!note || !note.trim()) {
      setValidationMessage("Please enter a note before submitting.");
      setTimeout(() => setValidationMessage(""), 2500);
      return;
    }
    setAddingNote(true);
    try {
      const apiUrl = "/server/service_notes_function/create-note";
      const params = {
        Service_Request_Id: paramsFromUrl.id,
        Note_Content: note,
      };

      const response = await axios.post(apiUrl, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setArrayNotes([...arrayNotes, { "Note Content": note }]);
        fetchNotesData();
      } else {
        console.error("Error adding note:", response.data.error);
      }
    } catch (error) {
      console.error("Error adding note:", error);
    }
    const fetchNotesData = async () => {
      const apiUrl = "/server/service_notes_function/get-notes";
      const params = {
        Record_Id: paramsFromUrl.id,
      };

      try {
        const response = await axios.get(apiUrl, { params });
        const notesWithIds = response.data.Notes.map((note, index) => ({
          ...note,
          Note_Id: note.id,
        }));
        setArrayNotes(notesWithIds);
        setNote("");
      } catch (error) {
        console.error("Error fetching notes data:", error);
      } finally {
        setAddingNote(false);
      }
    };
    fetchNotesData();
  };

  const handleButtonClicks = (button) => {
    setActiveButton(button);
  };

  const handleEditClick = (index) => {
    setEditNoteIndex(index);
    setEditNoteContent(arrayNotes[index]["Note Content"]);
    setEditedNoteId(arrayNotes[index]["Note id"]);
  };
  useEffect(() => {
    if (editNoteIndex === null) {
      setEditNoteContent(""); // Clear the input field if needed
    }
  }, [editNoteIndex]);

  const handleUpdateClick = async (index) => {
    try {
      const apiUrl = "/server/service_notes_function/edit-note";
      const params = {
        Note_Id: editedNoteId,
        Note_Content: editNoteContent,
      };

      const response = await axios.post(apiUrl, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        const updatedNotes = [...arrayNotes];
        updatedNotes[index]["Note Content"] = editNoteContent;
        setArrayNotes(updatedNotes);
      } else {
        console.error("Error updating note:", response.data.error);
      }
    } catch (error) {
      console.error("Error updating note:", error);
    }

    // Fetch updated notes
    const fetchNotesData = async () => {
      try {
        const apiUrl = "/server/service_notes_function/get-notes";
        const response = await axios.get(apiUrl, {
          params: { Record_Id: paramsFromUrl.id },
        });

        const notesWithIds = response.data.Notes.map((note) => ({
          ...note,
          Note_Id: note.id,
        }));

        setArrayNotes(notesWithIds);
      } catch (error) {
        console.error("Error fetching notes data:", error);
      }
    };

    await fetchNotesData(); // Wait for the data to be fetched before closing the text area

    setEditNoteIndex(null); // Close the text area
    setEditedNoteId(null);
  };

  const handleCancelEdit = () => {
    setEditNoteIndex(null);
    setEditNoteContent("");
  };

  useEffect(() => {
    const fetchAttachments = async () => {
      setLoading(true);
      const apiUrl = "/server/service_notes_function/get-attachments";
      const params = {
        Record_Id: paramsFromUrl.id,
      };

      try {
        const response = await axios.get(apiUrl, { params });
        console.log("Attachments response data:", response.data);
        if (response.data && response.data.Attachments) {
          setImageUrls(response.data.Attachments);
        } else {
          console.error("Error fetching attachments: no attachments found");
        }
      } catch (error) {
        console.error("Error fetching attachments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAttachments();
  }, [paramsFromUrl.id]);

  useEffect(() => {
    const fetchDiagnosticFiles = async () => {
      try {
        const response = await axios.get("/server/jad_group_website_function/diagnostic-files", {
          params: { Record_Id: paramsFromUrl.id },
        });
        if (response.data && response.data.DiagnosticFiles) {
          setDiagnosticFiles(response.data.DiagnosticFiles);
        }
      } catch (error) {
        console.error("Error fetching diagnostic files:", error);
      }
    };

    fetchDiagnosticFiles();
  }, [paramsFromUrl.id]);

  useEffect(() => {
    const fetchFieldServiceReports = async () => {
      try {
        const response = await axios.get("/server/jad_group_website_function/field-service-reports", {
          params: { Record_Id: paramsFromUrl.id },
        });
        if (response.data && response.data.FieldServiceReports) {
          setFieldServiceReports(response.data.FieldServiceReports);
        }
      } catch (error) {
        console.error("Error fetching field service reports:", error);
      }
    };

    fetchFieldServiceReports();
  }, [paramsFromUrl.id]);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingFile(true);
    setUploadMessage("");

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("recordId", paramsFromUrl.id);

      const response = await axios.post(
        "/server/service_notes_function/upload-attachment",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("Upload response:", response.data);
      setUploadMessage("File uploaded successfully!");

      // Refresh attachments list
      const attachRes = await axios.get("/server/service_notes_function/get-attachments", {
        params: { Record_Id: paramsFromUrl.id },
      });
      if (attachRes.data?.Attachments) {
        setImageUrls(attachRes.data.Attachments);
      }
    } catch (err) {
      console.error("Upload error:", err);
      setUploadMessage(err.response?.data?.message || "Failed to upload file");
    } finally {
      setUploadingFile(false);
      e.target.value = "";
    }
  };

  if (!serviceDetailsData) {
    return (
      <div
        className="loader"
        style={{ textAlign: "justify", marginTop: "350px" }}
      ></div>
    );
  }

  return (
    <div className="ServiceNotesStatus_box">
      <TopHeader />
      <div className="secondHeader-fixed-style">
        <Secondheader />
      </div>
      {validationMessage && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}>
          <div style={{
            backgroundColor: "#fff",
            borderTop: "4px solid #f3cf05",
            padding: "28px 36px",
            borderRadius: "8px",
            textAlign: "center",
            maxWidth: "420px",
            width: "90%",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
            fontFamily: "Open Sans, sans-serif",
            animation: "fadeIn 0.3s ease-in-out",
          }}>
            <div style={{
              fontSize: "32px",
              marginBottom: "12px",
              color: "#f3cf05",
            }}>
              ⚠
            </div>
            <p style={{
              fontSize: "16px",
              color: "#145C91",
              margin: "0 0 20px 0",
              fontWeight: "600",
            }}>
              {validationMessage}
            </p>
            <button
              onClick={() => setValidationMessage("")}
              style={{
                backgroundColor: "#145C91",
                color: "#fff",
                border: "none",
                padding: "10px 32px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "600",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div className="Inside_details">
        <div className="Small_boxes_s">
          <h2 className="ID_product">
            <span className="sub-span">
              SR#
              <span className="sup-span"> {serviceDetailsData["SR Number"] || "N/A"} </span>
            </span>
          </h2>
          <p>
            <span style={{ fontSize: "14px" }}>
              {serviceDetailsData.Description}
            </span>
          </p>
          <div className="headers">
            <div className="T_ren">
              <br />
              <span className="type">
                Type{" "}
                <span className="type-span">{serviceDetailsData.Type}</span>
              </span>
              <br />
              <br />
              <span className="sts">
                Status{" "}
                <span className="span-status">{serviceDetailsData.Status}</span>
              </span>
            </div>
          </div>
          <div className="Group_d">
            <p>
              <b>Service Request Owner:</b>{" "}
              {serviceDetailsData["Service Owner"]}
            </p>
            <p>
              <b>Machine Name: </b>
              {serviceDetailsData["Machine Name"]}
            </p>
            <p>
              <b>Field Service Report:</b>
              {fieldServiceReports && fieldServiceReports.length > 0 ? (
                fieldServiceReports.map((file, index) => (
                  <a
                    key={index}
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "block", marginLeft: "10px", fontSize: "13px", color: "#017cc2" }}
                  >
                    {file.format === "image" ? "📷 " : "📎 "}
                    {file.fileName}
                  </a>
                ))
              ) : (
                <span style={{ fontSize: "13px", marginLeft: "10px" }}>
                  No Files
                </span>
              )}
            </p>
            <p>
              <b>Diagnostic/Other Files: -</b>
              {diagnosticFiles && diagnosticFiles.length > 0 ? (
                diagnosticFiles.map((file, index) => (
                  <a
                    key={index}
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    download={file.fileName}
                    style={{
                      display: "block",
                      fontSize: "13px",
                      marginLeft: "10px",
                      marginTop: "4px",
                      color: "#017CC2",
                      textDecoration: "none",
                    }}
                  >
                    <FontAwesomeIcon icon={faFileDownload} style={{ marginRight: "5px" }} />
                    {file.fileName}
                  </a>
                ))
              ) : (
                <span style={{ fontSize: "13px", marginLeft: "10px" }}>
                  No Files
                </span>
              )}
            </p>
            {serviceDetailsData["Assigned Engineer"] && (
              <SkyBlueBox
                imageUrl={MenImg}
                name={serviceDetailsData["Assigned Engineer"].Name}
                email={serviceDetailsData["Assigned Engineer"].Email}
                phone={serviceDetailsData["Assigned Engineer"].Mobile}
              />
            )}
          </div>

          <div>
            {serviceDetailsData["Status"] === "Closed" && (
              <>
                {/* <div className="contract-box">
                  <h3>Service Ticket Contract Usage</h3>
                  <span style={{ color: '#017CC2' }}>
                    <h2>{serviceDetailsData["Service Ticket Contract Usage"]}</h2>
                  </span>
                </div> */}

                <div style={{ marginTop: "10px" }} className="contract-box">
                  <h3>Service Ticket Contract Usage</h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Parts Cap</h5>
                    <span style={{ color: "#017CC2", fontSize: "13px" }}>
                      <h2>{serviceDetailsData["Parts Cap"]}</h2>
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Calibrations</h5>
                    <span style={{ color: "#017CC2", fontSize: "13px" }}>
                      <h2>{serviceDetailsData["Calibrations"]}</h2>
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>On-Site Service Visits</h5>
                    <span style={{ color: "#017CC2", fontSize: "13px" }}>
                      <h2>{serviceDetailsData["On-Site Service Visits"]}</h2>
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>2nd Level Remote Technical Support Hours</h5>
                    <span style={{ color: "#017CC2", fontSize: "13px" }}>
                      <h2>
                        {
                          serviceDetailsData[
                          "2nd Level Remote Technical Support Hours"
                          ]
                        }
                      </h2>
                    </span>
                  </div>
                </div>
              </>
            )}
            {serviceDetailsData["Status"] === "Open" && (
              <>
                <div style={{ marginTop: "10px" }} className="contract-box">
                  <div>
                    <div>
                      <h3>CMA Balance</h3>
                    </div>

                    {Object.entries(serviceDetailsData["CMA Balance"]).map(
                      ([key, value]) => (
                        <div
                          key={key}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h5 style={{ width: "150px" }}>{key}</h5>
                          <span style={{ color: "#017CC2", fontSize: "13px" }}>
                            <h2 style={{ fontSize: "18px" }}>{value || "-"}</h2>
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="Two_boxes_s">
          <div className="SwitchButton">
            <div
              className={`Service-Notes-Status ${activeButton === "Service-Notes-Status" ? "ActiveButton" : ""
                }`}
              onClick={() => handleButtonClicks("Service-Notes-Status")}
            >
              Service Notes & Status
            </div>
            <div
              className={`Attachments ${activeButton === "Attachments" ? "ActiveButton" : ""
                }`}
              onClick={() => handleButtonClicks("Attachments")}
            >
              Attachments
            </div>
          </div>
          {activeButton === "Service-Notes-Status" && (
            <div className="Notes_Box">
              <div className="Input_note">
                <textarea
                  name="comment"
                  form="usrform"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Add a note here..."
                />
                <button onClick={handleAddClick} className="AddNote" disabled={addingNote}
                  style={addingNote ? { opacity: 0.7, cursor: "not-allowed" } : {}}>
                  {addingNote ? "Adding..." : "Add Note"}
                </button>
                {successMessage && (
                  <div className="success-message">{successMessage}</div>
                )}
                <div className="Add_note">
                  <h3>Your Notes</h3>

                  {arrayNotes && arrayNotes.length > 0 ? (
                    arrayNotes.map((note, index) => (
                      <ul className="Notes">
                        <li className="listed-stylings" key={index}>
                          {editNoteIndex === index ? (
                            <textarea
                              value={editNoteContent}
                              onChange={(e) =>
                                setEditNoteContent(e.target.value)
                              }
                            />
                          ) : (
                            <p className="Content-para">
                              {" "}
                              {note["Note Content"]}
                            </p>
                          )}
                          <strong
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              width: "auto",
                            }}
                          >
                            <img
                              style={{
                                width: "30px",
                                backgroundColor: "white",
                                cursor: "pointer",
                              }}
                              src={calendaricon}
                              alt="time icon"
                            />
                            <p>{note["Time"]}</p>
                            {editNoteIndex === index ? (
                              <>
                                <div key={note.Note_Id}>
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "white",
                                    }}
                                    onClick={() =>
                                      handleUpdateClick(index, note.Note_Id)
                                    }
                                  >
                                    <img
                                      style={{
                                        width: "30px",

                                        backgroundColor: "white",
                                        cursor: "pointer",
                                      }}
                                      src={updateIcon}
                                      alt="Edit-image"
                                    ></img>
                                  </button>
                                </div>

                                <button
                                  style={{
                                    border: "none",
                                    backgroundColor: "white",
                                  }}
                                  onClick={handleCancelEdit}
                                >
                                  <img
                                    style={{
                                      width: "25px",
                                      backgroundColor: "white",
                                      cursor: "pointer",
                                    }}
                                    src={cancelIcon}
                                    alt="Cancel-image"
                                  ></img>
                                </button>
                              </>
                            ) : (
                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "white",
                                }}
                                onClick={() => handleEditClick(index)}
                              >
                                <img
                                  style={{
                                    width: "25px",
                                    backgroundColor: "white",
                                    cursor: "pointer",
                                  }}
                                  src={editIcon}
                                  alt="Edit-image"
                                ></img>
                              </button>
                            )}
                          </strong>
                        </li>
                      </ul>
                    ))
                  ) : (
                    <ul className="Notess">
                      <li>No notes available.</li>
                    </ul>
                  )}
                  <div>
                    <div className="parts-heading-container">
                      <h3>Parts Requested</h3>
                      <button
                        className="Add-button-parts"
                        onClick={handleAddPartClick}
                      >
                        Add Parts
                      </button>
                    </div>
                    {showForm && (
                      <form className="parts_Form" onSubmit={handleFormSubmit}>
                        <input
                          type="text"
                          name="PartNo"
                          placeholder="PartNo"
                          value={newPart["PartNo"]}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          name="Description"
                          placeholder="Description"
                          value={newPart["Description"]}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="number"
                          name="Quantity"
                          placeholder="Quantity"
                          value={newPart["Quantity"]}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: "10px" }}
                        />

                        <div className="bew_ResponsiveClass">
                          <button
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              border: "none",
                              borderRadius: "15px",
                              padding: "5px",
                              cursor: "pointer",
                            }}
                            type="submit"
                          >
                            <FaCheck size={20} />
                          </button>

                          <button
                            style={{
                              marginLeft: "10px",
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "15px",
                              padding: "5px",
                              cursor: "pointer",
                            }}
                            onClick={handleCancelForm}
                            type="button"
                          >
                            <FaTimes size={20} />
                          </button>
                        </div>
                      </form>
                    )}
                    <div className="Table_1">
                      <table className="tabler-1">
                        <thead>
                          <tr>
                            <th className="th1">Part No</th>
                            <th className="th1">Description</th>
                            <th className="th1">Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {partsRequested.length > 0 ? (
                            partsRequested.map((part, index) => (
                              <tr key={index}>
                                <td className="tabledata-part">
                                  {part["PartNo"]}
                                </td>
                                <td className="tabledata-desc">
                                  {part["Description"]}
                                </td>
                                <td className="tabledata-quantity">
                                  {part["Quantity"]}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3">No parts requested.</td>
                            </tr>
                          )} */}
                          {partsRequested.length > 0 ? (
                            partsRequested.map((part, index) => (
                              <tr key={index}>
                                <td className="tabledata-part">
                                  {part.PartNo || part.part_no || "N/A"}
                                </td>
                                <td className="tabledata-desc">
                                  {part.Description || part.description || "N/A"}
                                </td>
                                <td className="tabledata-quantity">
                                  {part.Quantity || part.quantity || 0}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3">No parts requested.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <h3>Service Request Items</h3>
                  <div className="Table_2">
                    <div
                      className="mobile-arrow"
                      onClick={toggleTableVisibility}
                      style={{ display: "none" }}
                    >
                      {areAdditionalColumnsVisible ? "▲" : "▼"}
                    </div>
                    <div className="table-responsive">
                      <table
                        className={`tabler-2 ${isTableVisible ? "expanded" : ""
                          }`}
                      >
                        <thead>
                          <tr className="wrap-table">
                            <th className="th2">Type</th>
                            <th className="th2">Status</th>
                            <th className="th2">Shipping Method</th>
                            <th
                              className={`th2 ${areAdditionalColumnsVisible ? "" : "hidden"
                                }`}
                            >
                              Tracking Number
                            </th>
                            <th
                              className={`th2 ${areAdditionalColumnsVisible ? "" : "hidden"
                                }`}
                            >
                              Date of Service
                            </th>
                            <th
                              className={`th2 ${areAdditionalColumnsVisible ? "" : "hidden"
                                }`}
                            >
                              Note
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {serviceDetailsData["Service Request Items"] &&
                            Array.isArray(
                              serviceDetailsData["Service Request Items"]
                            ) ? (
                            serviceDetailsData["Service Request Items"].map(
                              (item, index) => (
                                <tr className="wrap-table" key={index}>
                                  <td className="tabledata-type">
                                    {item.Type}
                                  </td>
                                  <td className="tabledata-status">
                                    {item.Status}
                                  </td>
                                  <td className="tabledata-shipping">
                                    {item["Shipping Method"]}
                                  </td>

                                  <td
                                    className={`tabledata-tracking ${areAdditionalColumnsVisible
                                      ? ""
                                      : "hidden"
                                      }`}
                                  >
                                    {item["Tracking Number"]}
                                  </td>
                                  <td
                                    className={`tabledata-date ${areAdditionalColumnsVisible
                                      ? ""
                                      : "hidden"
                                      }`}
                                  >
                                    {item["Date of Service"]}
                                  </td>
                                  <td
                                    className={`tabledata-notes ${areAdditionalColumnsVisible
                                      ? ""
                                      : "hidden"
                                      }`}
                                  >
                                    {item.Notes}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={6}>No service request items.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeButton === "Attachments" && (
            <div className="Attachments_box">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <h2 style={{ margin: 0 }}>Attachments ({ImgUrls.length})</h2>
                <label
                  style={{
                    backgroundColor: "#017CC2",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: uploadingFile ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    opacity: uploadingFile ? 0.6 : 1,
                  }}
                >
                  {uploadingFile ? "Uploading..." : "+ Upload File"}
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                    disabled={uploadingFile}
                  />
                </label>
              </div>
              {uploadMessage && (
                <p style={{
                  color: uploadMessage.includes("success") ? "green" : "red",
                  fontSize: "13px",
                  margin: "5px 0",
                }}>
                  {uploadMessage}
                </p>
              )}
              <div className="AllStoreImg">
                {ImgUrls.map((attachment, index) => {
                  if (attachment.format === "file") {
                    return (
                      <a
                        key={index}
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download={attachment.fileName}
                        className="attachment-card"
                      >
                        <div className="attachment-thumb attachment-file-thumb">
                          <FontAwesomeIcon icon={faFileDownload} size="2x" />
                        </div>
                        <p className="attachment-name">{attachment.fileName}</p>
                      </a>
                    );
                  } else {
                    return (
                      <a
                        key={index}
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download={attachment.fileName}
                        className="attachment-card"
                        style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
                      >
                        <img
                          src={attachment.url}
                          alt={attachment.fileName || `Image ${index + 1}`}
                          className="attachment-thumb"
                          onError={(e) => {
                            e.target.style.display = "none";
                            console.error(`Failed to load image: ${attachment.url}`);
                          }}
                        />
                        <p className="attachment-name">{attachment.fileName}</p>
                      </a>
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceNotesStatus;
